import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PaginatorModule } from 'primeng/paginator';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-paginator-control',
  standalone: true,
  template: `
    <div class="fc-paginator-container">
      <p-paginator
        [first]="first"
        [rows]="rows"
        [totalRecords]="totalRecords"
        [rowsPerPageOptions]="rowsPerPageOptions"
        [showCurrentPageReport]="showCurrentPageReport"
        [showPageLinks]="true"
        [showJumpToPageDropdown]="false"
        [currentPageReportTemplate]="currentPageReportTemplate"
        (onPageChange)="onPageChange($event)"
        appendTo="body"
      >
      </p-paginator>
    </div>
  `,
  styleUrl: './paginator-control.component.scss',
  imports: [PaginatorModule, CommonModule],
})
export class PaginatorControlComponent {
  @Input() first: number = 0;
  @Input() rows: number = 10;
  @Input() totalRecords: number = 0;
  @Input() rowsPerPageOptions: number[] = [5, 10, 20, 30];
  @Input() showCurrentPageReport: boolean = true;
  @Input() currentPageReportTemplate: string =
    'A mostrar {first} a {last} de {totalRecords} registos';
  @Output() pageChange = new EventEmitter<any>();

  onPageChange(event: any) {
    this.pageChange.emit(event);
  }
}
